import React, { Component } from 'react'
import getLabel from '../../utilities/label.js'
import { Link } from 'react-router-dom'

export default class UserRow extends Component {
  address() {
    const user = this.props.user
    return user.address ?
      <div>{ user.address }</div> :
      <div>{ getLabel('address') + getLabel('not_provided') }</div>
  }

  city() {
    const user = this.props.user
    return user.city ?
      <div>{ user.city }</div> :
      <div>{ getLabel('city') + getLabel('not_provided') }</div>
  }

  state() {
    const user = this.props.user
    return user.state ?
      <div>{ user.state }</div> :
      <div>{ getLabel('state') + getLabel('not_provided') }</div>
  }

  postal_code() {
    const user = this.props.user
    return user.postal_code ?
      <div>{ user.postal_code }</div> :
      <div>{ getLabel('postal_code') + getLabel('not_provided') }</div>
  }

  phone() {
    const user = this.props.user
    return user.phone ?
      <div>{ user.phone }</div> :
      <div>{ getLabel('phone') + getLabel('not_provided') }</div>
  }

  render() {
    const user = this.props.user
    if ( user.is_biz_card) {
      return (
        <div>
          <span className='blue-header'>
            <h3>{ getLabel('business_card_exchange') }</h3>
          </span>
          <div className="business-card-info">
            <div className="name">{ user.first_name + ' ' + user.last_name }</div>
            <div>{ user.email }</div>
            <div>{ this.address() }</div>
            <div>{ this.city() }</div>
            <div>{ this.state() }</div>
            <div>{ this.postal_code() }</div>
            <div>{ this.phone() }</div>
          </div>
        </div>
      )
    } else {
      return (
        <div>
          <span className='blue-header'>
            <h3>{ getLabel('business_card_exchange') }</h3>
          </span>
          <Link
            to='/scanner'>
            <button className='edit-profile'>
              <i className="fa fa-address-card-o"></i>  { getLabel('exchange_business_card') }
            </button>
          </Link>
        </div>
      )
    }
  }
}
